<template>
  <svg 
    class="arrow" 
    :class="[{ 'right': right, 'is-active': active }, size, anchorClass]"
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 27.48 18.38"
  >
    <g v-if="right">
      <line 
        class="body" 
        :stroke-width="strokeWidth" 
        x1="0" y1="8.9" x2="26" y2="8.9"
      />
      <polyline class="head" :stroke-width="strokeWidth" points="17.7,17.2 26.1,8.8 18,0.3 "/>
    </g>
    <g v-else>
      <line 
        class="body" 
        :stroke-width="strokeWidth" 
        x1="26.8" y1="8.7" x2="0.8" y2="8.7"
      />
      <polyline class="head" :stroke-width="strokeWidth" points="9.1,0.4 0.7,8.7 8.8,17.2 "/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'arrow',
  props: {
    right: Boolean,
    active: Boolean,
    size: String,
    strokeWidth: Number,
    anchor: String
  },
  computed: {
    anchorClass () {
      return {
        'anchor-right': this.anchor === 'right'
      }
    }
  }
}
</script>

<style lang="sass" scoped>

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

.body
  transform-origin: center left
  .right &
    transform-origin: center left
  .anchor-right &
    transform-origin: center right
    .right &
      transform-origin: center right

.head

.head, .body
  transition: transform 100ms ease-out
  stroke-width: 2px
  stroke: #000
  fill: none

.arrow
  width: 20px
  height: 14px
  overflow: visible
  cursor: pointer
  &.large
    width: 30px
    height: 20px
    +small(max)
      width: 26px
  &:hover, &.is-active
    .body
      transform: scaleX(1.5)
  &.right:hover, &.right.is-active
    .head
      transform: translateX(13px)

  &.right.anchor-right:hover, &.right.anchor-right.is-active, &.anchor-right:hover, &.anchor-right.is-active
    .head
      transform: none

</style>



// WEBPACK FOOTER //
// Arrow.vue?a50c7f86